import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Button,
    Slide,
} from '@material-ui/core';
import CalculateInequalityForm from './calculateInequalityForm';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

/**
 * Componente para renderizar el formulario de calculo de medidas de desigualdades en un dialogo
 * Jhoan López <jhoanlt19@gmail.com>
 * @param {*} param0 
 */
const CalculateInequalityDialog = ({
    indicatorId,
    indicators,
    availablePeriods,
}) => {
    const indicator = indicators[indicatorId] || null;
    const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return(
        <div>
            {indicatorId &&
                <div>
                    <Button
                        variant="outlined" 
                        color="primary" 
                        onClick={handleClickOpen}
                        style={{marginLeft : 2}}
                    >
                        Calcular medidas
                    </Button>
                    <Dialog
                        open={open}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={handleClose}
                        fullWidth
                        fullScreen
                    >
                        <DialogTitle>
                            {`Calcular medidas de desigualdades para el indicador: ${indicator ? indicator.name : ''}`}
                        </DialogTitle>
                        <DialogContent>
                            <CalculateInequalityForm
                                indicator        = {indicator}
                                availablePeriods = {availablePeriods}
                                handleClose      = {handleClose}
                            />
                        </DialogContent>
                    </Dialog>
                </div>
            }
        </div>
    );
};

const mapStateToProps = ({filters, data}) => ({
    indicatorId      : filters.get("disease"),
    indicators       : filters.get('indicators'),
    availablePeriods : data.get('availablePeriods'),
});

CalculateInequalityDialog.propTypes = {
    indicatorId      : PropTypes.string,
    indicators       : PropTypes.object,
    availablePeriods : PropTypes.array,
}

export default connect(mapStateToProps, null)(CalculateInequalityDialog);


// WEBPACK FOOTER //
// ./src/components/tabs/calculateInequalityDialog.js